import AdminUserRoutes from './admin/admin_users'
import AdminAccountRoutes from './admin/admin_accounts'
const AdminRoutes = [...AdminUserRoutes, ...AdminAccountRoutes]
export default AdminRoutes
